'use client'

import { useEffect, useRef, useState } from 'react'
import { Plus, Minus } from 'lucide-react'

export function FaqToggleIcon() {
  const ref = useRef<SVGSVGElement | null>(null)
  // eslint-disable-next-line react-doctor/no-initialize-state -- false is a DOM-sourced initial value read from details.open; the effect syncs it immediately
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    const details = ref.current?.closest('details')
    if (!details) return

    const sync = () => setIsOpen(details.open)
    if (details.open !== isOpen) sync()
    details.addEventListener('toggle', sync)
    return () => details.removeEventListener('toggle', sync)
    // isOpen intentionally omitted — sync function reads the live DOM value
    // and the toggle listener handles every subsequent change.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const Icon = isOpen ? Minus : Plus

  return (
    <Icon
      ref={ref as React.Ref<SVGSVGElement>}
      aria-hidden="true"
      className="flex-shrink-0 ml-3"
      style={{
        width: 16,
        height: 16,
        color: isOpen ? 'var(--tlsr-tally)' : 'var(--tlsr-fg-subtle)',
        transition: `color var(--motion-duration-fast) var(--motion-ease-standard)`,
      }}
    />
  )
}
